import { VITE_GTM_ID } from '@/constant';
import { useApiError } from '@/errorHandling/context/ApiErrorContext';
import { ApolloProvider } from '@apollo/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import type React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { createApolloClient } from './gql/client';
import { routeTree } from './routeTree.gen';

const router = createRouter({ routeTree: routeTree, notFoundMode: 'root' });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const App: React.FC = () => {
  const { setApiError } = useApiError();
  const client = createApolloClient(setApiError);

  return (
    <HelmetProvider>
      <Helmet>
        <title>eMBA by GLOBIS</title>
        {VITE_GTM_ID && (
          <>
            <script
              async
              src={`https://www.googletagmanager.com/gtag/js?id=${VITE_GTM_ID}`}
            />
            <script>
              {`
                window.dataLayer = window.dataLayer || [];
                function gtag() { dataLayer.push(arguments); }
                gtag('js', new Date());
                gtag('config', '${VITE_GTM_ID}');
              `}
            </script>
          </>
        )}
      </Helmet>
      <ApolloProvider client={client}>
        <RouterProvider router={router} />
      </ApolloProvider>
    </HelmetProvider>
  );
};

export default App;
